(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["CUSTOM-PRO"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kh-pdp')) {
  class KhPdp extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      } else {
        this.init();
      }
    }

    disconnectedCallback() {
      clearInterval(this._viewTimer);
      clearTimeout(this._mt);
      clearTimeout(this._rt);
      if (this._sbar) this._sbar.remove();
      if (this._io) this._io.disconnect();
      if (this._onDocKey) document.removeEventListener('keydown', this._onDocKey);
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (this.lbOpen) document.documentElement.style.overflow = '';
      this._ready = false;
    }

    init() {
      if (this._ready) return;
      this._ready = true;
      const $ = (s) => this.querySelector(s);
      const $$ = (s) => Array.from(this.querySelectorAll(s));

      this.track = $('[data-track]');
      this.main = $('[data-main]');
      if (!this.track || !this.main) return;
      this.slides = $$('.kpdp__slide');
      this.thumbs = $$('.kpdp__thumb');
      this.thumbsBox = $('[data-thumbs]');
      this.dots = $$('.kpdp__dot');
      this.index = 0;
      this.variants = [];
      try { this.variants = JSON.parse($('[data-variants-json]').textContent); } catch (e) {}
      this.cfg = this.dataset;
      this.qty = $('[data-qty]');
      this.msg = $('[data-msg]');

      this.initGallery();
      this.initLightbox();
      this.initShare();
      this.initVariants();
      this.initQty();
      this.initPartialCod();
      this.initCart();
      this.initPincode();
      this.initSocial();
      this.initStickyBar();

      const start = parseInt(this.cfg.start || '0', 10) || 0;
      this.goTo(start, false);
      requestAnimationFrame(() => this.goTo(this.index, false));
    }

    /* ---------- helpers ---------- */
    isMobile() {
      return window.matchMedia('(max-width: 767px)').matches;
    }
    currentVariant() {
      const groups = this.querySelectorAll('.kpdp__vgroup');
      if (!groups.length) return this.variants[0];
      const picked = Array.from(groups).map((g) => {
        const c = g.querySelector('input:checked');
        return c ? c.value : null;
      });
      return this.variants.find((v) => v.options.every((o, i) => o === picked[i]));
    }
    showMsg(text, isError) {
      if (!this.msg) return;
      this.msg.textContent = text;
      this.msg.classList.toggle('is-error', !!isError);
      this.msg.hidden = false;
      clearTimeout(this._mt);
      this._mt = setTimeout(() => (this.msg.hidden = true), 4000);
    }

    /* ---------- gallery ---------- */
    centerTo(i, animate) {
      const el = this.slides[i];
      if (!el) return;
      const left = el.offsetLeft - (this.track.clientWidth - el.offsetWidth) / 2;
      this.track.scrollTo({ left, behavior: animate ? 'smooth' : 'auto' });
    }

    setActive(i, animate) {
      this.thumbs.forEach((t, k) => {
        const on = k === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on && this.thumbsBox && this.thumbsBox.offsetParent !== null) {
          const top = t.offsetTop - this.thumbsBox.clientHeight / 2 + t.offsetHeight / 2;
          this.thumbsBox.scrollTo({ top, behavior: animate ? 'smooth' : 'auto' });
        }
      });
      this.dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      this.slides.forEach((s, k) => {
        s.classList.toggle('is-active', k === i);
        if (k !== i) s.querySelectorAll('video').forEach((v) => v.pause());
      });
      [i - 1, i, i + 1].forEach((k) => {
        const im = this.slides[k] && this.slides[k].querySelector('img[loading="lazy"]');
        if (im) im.loading = 'eager';
      });
    }

    goTo(i, animate = true) {
      const max = this.slides.length - 1;
      if (max < 0) return;
      this.index = Math.max(0, Math.min(max, i));

      if (this.isMobile()) {
        this.track.style.transform = '';
        this.centerTo(this.index, animate);
      } else {
        if (!animate) this.track.classList.add('is-dragging');
        this.track.style.transform = `translateX(-${this.index * 100}%)`;
        if (!animate) { void this.track.offsetWidth; this.track.classList.remove('is-dragging'); }
      }
      this.setActive(this.index, animate);
    }

    initGallery() {
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.goTo(+t.dataset.index)));
      this.dots.forEach((d) => d.addEventListener('click', () => this.goTo(+d.dataset.index)));
      this.main.tabIndex = 0;
      this.main.addEventListener('keydown', (e) => {
        if (this.lbOpen) return;
        if (e.key === 'ArrowRight') this.goTo(this.index + 1);
        if (e.key === 'ArrowLeft') this.goTo(this.index - 1);
      });

      let raf = 0;
      this.track.addEventListener('scroll', () => {
        if (!this.isMobile()) return;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const center = this.track.scrollLeft + this.track.clientWidth / 2;
          let best = 0, bestDist = Infinity;
          this.slides.forEach((s, k) => {
            const d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - center);
            if (d < bestDist) { bestDist = d; best = k; }
          });
          if (best !== this.index) {
            this.index = best;
            this.setActive(best, true);
          }
        });
      }, { passive: true });

      this._onResize = () => {
        clearTimeout(this._rt);
        this._rt = setTimeout(() => this.goTo(this.index, false), 150);
      };
      window.addEventListener('resize', this._onResize);

      let sx = 0, sy = 0, dx = 0, dragging = false, horizontal = null;
      this.main.addEventListener('touchstart', (e) => {
        if (this.isMobile()) return;
        if (e.touches.length !== 1) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; dx = 0; horizontal = null; dragging = true;
      }, { passive: true });
      this.main.addEventListener('touchmove', (e) => {
        if (!dragging) return;
        const x = e.touches[0].clientX - sx, y = e.touches[0].clientY - sy;
        if (horizontal === null && (Math.abs(x) > 8 || Math.abs(y) > 8)) horizontal = Math.abs(x) > Math.abs(y);
        if (!horizontal) return;
        dx = x;
        this.track.classList.add('is-dragging');
        this.track.style.transform = `translateX(calc(-${this.index * 100}% + ${dx}px))`;
        if (e.cancelable) e.preventDefault();
      }, { passive: false });
      const end = () => {
        if (!dragging) return;
        dragging = false;
        this.track.classList.remove('is-dragging');
        const w = this.main.clientWidth || 1;
        if (horizontal && Math.abs(dx) > Math.min(60, w * 0.15)) this.goTo(this.index + (dx < 0 ? 1 : -1));
        else this.goTo(this.index);
      };
      this.main.addEventListener('touchend', end);
      this.main.addEventListener('touchcancel', end);
    }

    /* ---------- lightbox ---------- */
    initLightbox() {
      const lb = this.querySelector('[data-lb]');
      const img = this.querySelector('[data-lb-img]');
      if (!lb || !img) return;
      this.lbOpen = false;
      const imgs = this.slides.map((s) => s.querySelector('img[data-full]'));
      const show = (i) => {
        const n = imgs.length;
        if (!n) return;
        let k = ((i % n) + n) % n, guard = 0;
        while (!imgs[k] && guard++ < n) k = (k + 1) % n;
        if (!imgs[k]) return;
        this._lbIndex = k;
        img.src = imgs[k].dataset.full || imgs[k].src;
        img.alt = imgs[k].alt || '';
      };
      const open = (i) => {
        show(i);
        lb.hidden = false;
        this.lbOpen = true;
        document.documentElement.style.overflow = 'hidden';
        lb.querySelector('[data-lb-close]').focus();
      };
      const close = () => {
        lb.hidden = true;
        this.lbOpen = false;
        document.documentElement.style.overflow = '';
        img.removeAttribute('src');
      };
      this.slides.forEach((s, i) => {
        const im = s.querySelector('img[data-full]');
        if (!im) return;
        im.addEventListener('click', () => {
          if (this.isMobile() && i !== this.index) { this.goTo(i); return; }
          open(i);
        });
        im.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(i); } });
      });
      lb.querySelector('[data-lb-close]').addEventListener('click', close);
      lb.querySelector('[data-lb-prev]').addEventListener('click', () => { show(this._lbIndex - 1); this.goTo(this._lbIndex); });
      lb.querySelector('[data-lb-next]').addEventListener('click', () => { show(this._lbIndex + 1); this.goTo(this._lbIndex); });
      lb.addEventListener('click', (e) => { if (e.target === lb) close(); });
      this._onDocKey = (e) => {
        if (!this.lbOpen) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowRight') { show(this._lbIndex + 1); this.goTo(this._lbIndex); }
        if (e.key === 'ArrowLeft') { show(this._lbIndex - 1); this.goTo(this._lbIndex); }
      };
      document.addEventListener('keydown', this._onDocKey);
    }

    /* ---------- share ---------- */
    initShare() {
      const btn = this.querySelector('[data-share]');
      if (!btn) return;
      btn.addEventListener('click', async () => {
        const data = { title: document.title, url: location.href };
        try {
          if (navigator.share) { await navigator.share(data); return; }
          await navigator.clipboard.writeText(location.href);
          this.showMsg('Link copied');
        } catch (e) { /* user cancelled */ }
      });
    }

    /* ---------- variants ---------- */
    initVariants() {
      this.querySelectorAll('.kpdp__vgroup input').forEach((i) => i.addEventListener('change', () => this.updateVariant()));
    }
    setFact(boxSel, valSel, value) {
      const box = this.querySelector(boxSel);
      if (!box) return;
      const text = (value == null ? '' : String(value)).trim();
      box.hidden = !text;
      const el = this.querySelector(valSel);
      if (el) el.textContent = text;
    }
    updateVariant() {
      const v = this.currentVariant();
      const atc = this.querySelector('[data-atc]');
      const buy = this.querySelector('[data-buy]');
      const atcText = this.querySelector('[data-atc-text]');
      const idInput = this.querySelector('[data-variant-id]');
      if (!v) {
        if (atc) atc.disabled = true;
        if (buy) buy.disabled = true;
        if (atcText) atcText.textContent = this.cfg.unavailable || 'Unavailable';
        if (this.syncBar) this.syncBar();
        return;
      }
      idInput.value = v.id;

      const srId = this.querySelector('[data-sr-form] [name="id"]');
      if (srId) srId.value = v.id;

      this.setFact('[data-weight-box]', '[data-weight]', v.weight);
      this.setFact('[data-servings-box]', '[data-servings]', v.servings);
      this.setFact('[data-capsule-box]', '[data-capsule]', v.capsule);

      this.querySelector('[data-price]').textContent = v.priceFmt;
      const hasDisc = v.compare > v.price;
      this.querySelector('[data-mrp-line]').hidden = !hasDisc;
      this.querySelector('[data-discount]').hidden = !hasDisc;
      if (hasDisc) {
        this.querySelector('[data-mrp]').textContent = v.compareFmt;
        this.querySelector('[data-discount]').textContent = Math.round(((v.compare - v.price) * 100) / v.compare) + '% off';
      }
      if (atc) atc.disabled = !v.available;
      if (buy) buy.disabled = !v.available;
      if (this.qty) {
        if (v.max > 0) this.qty.max = v.max; else this.qty.removeAttribute('max');
        if (v.max > 0 && +this.qty.value > v.max) this.qty.value = v.max;
      }
      if (atcText) atcText.textContent = v.available ? (this.cfg.atcLabel || 'Add To Cart') : (this.cfg.soldOut || 'Sold Out');
      if (v.media) {
        const idx = this.slides.findIndex((s) => +s.dataset.mediaId === v.media);
        if (idx > -1) this.goTo(idx);
      }
      if (this.syncBar) this.syncBar();
      try {
        const u = new URL(location.href); u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u);
      } catch (e) {}
    }

    /* ---------- partial COD box ---------- */
    initPartialCod() {
      const box = this.querySelector('[data-pcod]');
      if (!box) return;
      const pct = parseFloat(box.dataset.pct) || 10;
      const advEl = box.querySelector('[data-pcod-adv]');
      const restEl = box.querySelector('[data-pcod-rest]');
      const fmt = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 });
      const update = () => {
        const v = this.currentVariant();
        if (!v) return;
        const qty = (this.qty && parseInt(this.qty.value, 10)) || 1;
        const total = (v.price * qty) / 100;
        const adv = Math.round((total * pct) / 100);
        advEl.textContent = fmt.format(adv);
        restEl.textContent = fmt.format(total - adv);
      };
      const actions = this.querySelector('[data-actions]');
      if (actions) {
        actions.addEventListener('click', () => setTimeout(update, 0));
        actions.addEventListener('input', update);
        actions.addEventListener('change', update);
      }
      this.querySelectorAll('.kpdp__vgroup input').forEach((i) => i.addEventListener('change', () => setTimeout(update, 0)));
      update();
    }

    /* ---------- quantity ---------- */
    initQty() {
      if (!this.qty) return;
      const clamp = () => {
        let n = parseInt(this.qty.value, 10);
        const mx = parseInt(this.qty.max, 10);
        if (!n || n < 1) n = 1;
        if (mx && n > mx) n = mx;
        this.qty.value = n;
      };
      this.querySelector('[data-qty-minus]').addEventListener('click', () => { this.qty.value = (parseInt(this.qty.value, 10) || 1) - 1; clamp(); });
      this.querySelector('[data-qty-plus]').addEventListener('click', () => { this.qty.value = (parseInt(this.qty.value, 10) || 1) + 1; clamp(); });
      this.qty.addEventListener('change', clamp);
    }

    /* ---------- cart ---------- */
    cartSectionIds() {
      return (this.cfg.cartSections || '').split(',').map((s) => s.trim()).filter(Boolean);
    }
    cartSelectors() {
      const custom = (this.cfg.cartSelectors || '').split(',').map((s) => s.trim()).filter(Boolean);
      const defaults = [
        'cart-drawer', '#CartDrawer', '#cart-drawer', '.cart-drawer',
        'cart-notification', '#cart-notification',
        '#cart-icon-bubble', '.cart-icon-bubble', '.cart-count-bubble',
        '#cart-count', '.cart-count', '[data-cart-count]', '.header__cart-count'
      ];
      return custom.concat(defaults);
    }
    async addToCart() {
      const id = this.querySelector('[data-variant-id]').value;
      const quantity = parseInt(this.qty.value, 10) || 1;
      const payload = { items: [{ id: +id, quantity }] };
      const ids = this.cartSectionIds();
      if (ids.length) {
        payload.sections = ids.join(',');
        payload.sections_url = window.location.pathname;
      }
      const res = await fetch(this.cfg.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      let data = {};
      try { data = await res.json(); } catch (e) {}
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
      return data;
    }

    applySections(sections) {
      if (!sections) return;
      Object.keys(sections).forEach((sid) => {
        const html = sections[sid];
        if (!html) return;
        const wrap = document.getElementById('shopify-section-' + sid);
        if (!wrap) return;
        try {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('.shopify-section');
          if (wrap.querySelector('m-cart-drawer')) return;
          wrap.innerHTML = fresh ? fresh.innerHTML : html;
        } catch (e) {}
      });
    }

    patchMinimogDrawer(freshRoot) {
      const liveD = document.querySelector('#MinimogCartDrawer, m-cart-drawer');
      const freshD = freshRoot.querySelector('m-cart-drawer');
      if (!liveD || !freshD) return false;
      const li = liveD.querySelector('[data-minimog-cart-items]');
      const fi = freshD.querySelector('[data-minimog-cart-items]');
      if (li && fi) li.innerHTML = fi.innerHTML;
      const lf = liveD.querySelector('#MinimogCartDrawerFooter');
      const ff = freshD.querySelector('#MinimogCartDrawerFooter');
      if (lf && ff) lf.innerHTML = ff.innerHTML;
      liveD.classList.toggle('m-cart--empty', freshD.classList.contains('m-cart--empty'));
      return true;
    }

    /* NEW: fetch real page HTML (current page first, then /cart) and copy the fresh drawer */
    async syncDrawerFromHtml() {
      const urls = [window.location.pathname + window.location.search, this.cfg.cartUrl];
      for (const base of urls) {
        try {
          const sep = base.indexOf('?') > -1 ? '&' : '?';
          const res = await fetch(base + sep + 't=' + Date.now(), {
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'text/html' }
          });
          if (!res.ok) continue;
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          if (this.patchMinimogDrawer(doc)) return true;
        } catch (e) {
          console.warn('[kpdp] drawer html sync error', e);
        }
      }
      return false;
    }

    async syncFromPage() {
      try {
        const wraps = Array.from(document.querySelectorAll('[id^="shopify-section-"]'))
          .filter((w) => !this.contains(w) && !w.contains(this));
        const detected = wraps
          .filter((w) => /cart|drawer|header|mini/i.test(w.id) || w.querySelector('[class*="cart" i],[id*="cart" i]'))
          .map((w) => w.id.replace('shopify-section-', ''));
        const all = Array.from(new Set(this.cartSectionIds().concat(detected, ['cart-drawer'])));
        all.sort((x, y) => (/cart|drawer/i.test(y) ? 1 : 0) - (/cart|drawer/i.test(x) ? 1 : 0));
        const ids = all.slice(0, 8);

        const res = await fetch(window.location.pathname + '?sections=' + ids.join(',') + '&t=' + Date.now(), {
          headers: { Accept: 'application/json' }, credentials: 'same-origin'
        });
        if (!res.ok) { console.warn('[kpdp] sections fetch failed', res.status, ids); return; }
        const data = await res.json();

        let drawerDone = false;
        ids.forEach((id) => {
          const html = data[id];
          if (!html) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('.shopify-section') || doc.body;

          if (!drawerDone && fresh.querySelector('m-cart-drawer')) {
            drawerDone = this.patchMinimogDrawer(fresh);
            if (drawerDone) return;
          }

          const wrap = document.getElementById('shopify-section-' + id);
          if (!wrap) return;
          if (/header/i.test(id)) {
            const liveEls = wrap.querySelectorAll('[class*="count" i],[id*="count" i]');
            const freshEls = fresh.querySelectorAll('[class*="count" i],[id*="count" i]');
            liveEls.forEach((el, i) => {
              const f = freshEls[i];
              if (!f) return;
              el.textContent = f.textContent;
              el.hidden = f.hidden;
              el.className = f.className;
            });
          } else if (/cart|drawer|mini/i.test(id) && !wrap.querySelector('m-cart-drawer')) {
            wrap.innerHTML = fresh.innerHTML;
          }
        });
        if (!drawerDone) console.warn('[kpdp] cart drawer was not found in sections:', ids, Object.keys(data));
      } catch (e) { console.warn('[kpdp] cart sync error', e); }
    }

    async refreshCartUI(addData) {
      let cart = null;
      try { cart = await (await fetch(this.cfg.cartUrl + '.js', { headers: { Accept: 'application/json' } })).json(); } catch (e) {}

      if (addData && addData.sections) this.applySections(addData.sections);

      /* FIX: refresh drawer from real HTML first, old section-API method only as fallback */
      const drawerOk = await this.syncDrawerFromHtml();
      if (!drawerOk) await this.syncFromPage();

      if (cart) {
        document.querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden="true"], .cart-count, .cart-bubble__text-count, #cart-count, .header__cart-count').forEach((el) => {
          if (!this.contains(el)) el.textContent = cart.item_count;
        });
        const bubble = document.querySelector('.cart-count-bubble');
        if (bubble && cart.item_count > 0) bubble.hidden = false;
      }

      try {
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'kpdp', cartData: cart });
        }
      } catch (e) {}
      try {
        const ev = window.MinimogEvents, pe = window.MinimogTheme && window.MinimogTheme.pubSubEvents;
        if (ev && pe && pe.cartUpdate) ev.emit(pe.cartUpdate, { cart, source: 'kpdp' });
      } catch (e) {}
      ['cart:updated', 'cart:refresh', 'cart:update', 'cart:change', 'cart:build', 'ajaxProduct:added', 'product:added'].forEach((name) => {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart, source: 'kpdp' } }));
        window.dispatchEvent(new CustomEvent(name, { detail: { cart, source: 'kpdp' } }));
      });
      return cart;
    }

    isDrawerVisible() {
      const d = document.querySelector('#MinimogCartDrawer, m-cart-drawer');
      if (!d) return false;
      const inner = d.querySelector('.m-cart-drawer__inner') || d;
      const r = inner.getBoundingClientRect();
      const cs = getComputedStyle(inner);
      return r.width > 50 && r.right > 20 && r.left < window.innerWidth - 20 && cs.visibility !== 'hidden' && cs.display !== 'none';
    }

    async openDrawer() {
      const wait = (ms) => new Promise((r) => setTimeout(r, ms));
      const drawer = document.querySelector('#MinimogCartDrawer, m-cart-drawer, cart-drawer, #CartDrawer, #cart-drawer, .cart-drawer');

      /* 1. drawer's own open() */
      try { if (drawer && typeof drawer.open === 'function') drawer.open(); } catch (e) {}
      await wait(250);
      if (this.isDrawerVisible()) return true;

      /* 2. theme events */
      try {
        const ev = window.MinimogEvents, pe = window.MinimogTheme && window.MinimogTheme.pubSubEvents;
        if (ev && pe && pe.openCartDrawer) ev.emit(pe.openCartDrawer);
      } catch (e) {}
      ['cart:open', 'cart-drawer:open', 'drawer:open'].forEach((n) => document.dispatchEvent(new CustomEvent(n, { bubbles: true })));
      await wait(250);
      if (this.isDrawerVisible()) return true;

      /* 3. click the header cart icon (never let it navigate to /cart) */
      const icon = document.querySelector(
        '[data-open-cart-drawer], [data-action="open-cart-drawer"], [aria-controls="MinimogCartDrawer"], #cart-icon-bubble, header [data-cart-icon], header [aria-controls*="cart" i], header a[href$="/cart"], a[href$="/cart"][class*="cart" i], [class*="cart-icon" i]'
      );
      if (icon) {
        const guard = (e) => { if (!e.defaultPrevented) e.preventDefault(); };
        window.addEventListener('click', guard);
        try { icon.click(); } catch (e) {}
        window.removeEventListener('click', guard);
        await wait(300);
        if (this.isDrawerVisible()) return true;
      }

      /* 4. last resort: force open classes */
      if (drawer) {
        drawer.classList.add('m-cart-drawer--open', 'is-open', 'active', 'open');
        drawer.setAttribute('open', '');
        document.body.classList.add('m-cart-drawer-open');
        document.documentElement.classList.add('prevent-scroll');
        await wait(200);
        if (this.isDrawerVisible()) return true;
      }
      return false;
    }

    initCart() {
      const atc = this.querySelector('[data-atc]');
      const buy = this.querySelector('[data-buy]');
      const run = async (btn, buyNow) => {
        if (btn.disabled || btn.classList.contains('is-loading')) return;

        if (buyNow) { this.openShiprocket(); return; }

        btn.classList.add('is-loading');
        try {
          const data = await this.addToCart();
          await this.refreshCartUI(data);
          if (this.cfg.afterAdd === 'cart') {
            window.location.href = this.cfg.cartUrl;
          } else {
            /* always open the side cart drawer after Add To Cart */
            const opened = await this.openDrawer();
            if (!opened) this.showMsg(this.cfg.msgAdded || 'Added to cart');
          }
        } catch (err) {
          this.showMsg(err.message || 'Something went wrong', true);
        } finally {
          btn.classList.remove('is-loading');
        }
      };
      if (atc) atc.addEventListener('click', () => run(atc, false));
      if (buy) buy.addEventListener('click', () => run(buy, true));
    }

    /* ---------- Shiprocket checkout (headless) ---------- */
    openShiprocket() {
      const form = this.querySelector('[data-sr-form]');
      if (form) {
        const idEl = form.querySelector('[name="id"]');
        const qtyEl = form.querySelector('[name="quantity"]');
        const vid = this.querySelector('[data-variant-id]');
        if (idEl && vid) idEl.value = vid.value;
        if (qtyEl) qtyEl.value = (this.qty && parseInt(this.qty.value, 10)) || 1;
      }

      let tries = 0;
      const attempt = () => {
        let sr = form && form.querySelector('.sr-headless-checkout, button[name="sr-headless-button"]');
        if (!sr && this.cfg.srSelector) {
          try { sr = document.querySelector(this.cfg.srSelector); } catch (e) {}
        }
        if (sr) { sr.click(); return; }

        if (++tries < 12) return setTimeout(attempt, 250);

        this.addToCart()
          .then(() => { window.location.href = this.cfg.checkoutUrl || '/checkout'; })
          .catch((err) => this.showMsg(err.message || 'Something went wrong', true));
      };
      attempt();
    }

    /* ---------- mobile sticky bar ---------- */
    initStickyBar() {
      const actions = this.querySelector('[data-actions]');
      const root = this.closest('.kpdp');
      if (!actions || !root || !root.classList.contains('kpdp--sticky')) return;
      const atc = this.querySelector('[data-atc]');
      const buy = this.querySelector('[data-buy]');
      const buyLabel = this.querySelector('[data-buy-text]');
      const bar = document.createElement('div');
      bar.className = 'kpdp-sbar';
      bar.hidden = true;
      const cs = getComputedStyle(root);
      ['--kp-accent', '--kp-radius', '--kp-btn-radius', '--kp-atc', '--kp-buy-bg', '--kp-buy-text', '--kp-bottom-offset'].forEach((p) => bar.style.setProperty(p, cs.getPropertyValue(p)));
      bar.innerHTML = '<button type="button" class="kpdp-sbar__atc"></button>' + (buy ? '<button type="button" class="kpdp-sbar__buy"></button>' : '');
      document.body.appendChild(bar);
      this._sbar = bar;
      const sA = bar.querySelector('.kpdp-sbar__atc');
      const sB = bar.querySelector('.kpdp-sbar__buy');
      this.syncBar = () => {
        if (atc) { sA.textContent = this.querySelector('[data-atc-text]').textContent; sA.disabled = atc.disabled; }
        if (buy && sB) { sB.textContent = buyLabel ? buyLabel.textContent : buy.textContent.trim(); sB.disabled = buy.disabled; }
      };
      this.syncBar();
      if (atc) sA.addEventListener('click', () => atc.click());
      if (buy && sB) sB.addEventListener('click', () => buy.click());
      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver(([e]) => { this.syncBar(); bar.hidden = e.isIntersecting; });
        this._io.observe(actions);
      }
    }

    /* ---------- sold / viewing (random on every load) ---------- */
    initSocial() {
      const rnd = (a, b) => Math.floor(Math.random() * (b - a + 1)) + a;
      const n = (k, d) => { const x = parseInt(this.cfg[k], 10); return isNaN(x) ? d : x; };
      const sold = this.querySelector('[data-sold]');
      const hrs = this.querySelector('[data-hours]');
      const view = this.querySelector('[data-viewers]');
      if (sold) {
        const a = n('soldMin', 10), b = Math.max(a, n('soldMax', 60));
        sold.textContent = rnd(a, b);
      }
      if (hrs) {
        const a = n('hoursMin', 2), b = Math.max(a, n('hoursMax', 24));
        hrs.textContent = rnd(a, b);
      }
      if (view) {
        const min = n('viewMin', 15), max = Math.max(min, n('viewMax', 80));
        let cur = rnd(min, max);
        view.textContent = cur;
        clearInterval(this._viewTimer);
        this._viewTimer = setInterval(() => {
          cur = Math.min(max, Math.max(min, cur + rnd(-3, 3)));
          view.textContent = cur;
        }, 6000);
      }
    }

    /* ---------- pincode ---------- */
    initPincode() {
      const input = this.querySelector('[data-pin]');
      const btn = this.querySelector('[data-pin-btn]');
      const out = this.querySelector('[data-pin-result]');
      if (!input || !btn || !out) return;
      try { const saved = localStorage.getItem('kpdp_pincode'); if (saved) input.value = saved; } catch (e) {}
      const show = (text, ok) => { out.textContent = text; out.className = 'kpdp__pin-result ' + (ok ? 'is-ok' : 'is-err'); out.hidden = false; };
      const check = async () => {
        const pin = input.value.trim();
        if (!/^\d{6}$/.test(pin)) return show('Please enter a valid 6-digit pincode.', false);
        btn.disabled = true; btn.textContent = '...';
        try {
          const r = await fetch((this.cfg.pinApi || '').replace('{pincode}', encodeURIComponent(pin)));
          if (!r.ok) throw new Error('bad response');
          const d = await r.json();
          const ok = !!(d.serviceable ?? d.available ?? d.deliverable ?? d.success);
          const etd = d.etd || d.estimated_delivery || '';
          const text = d.message || (ok ? `Delivery available to ${pin}.${etd ? ' Estimated: ' + etd : ''}` : `Sorry, we do not deliver to ${pin} yet.`);
          show(text, ok);
          try { localStorage.setItem('kpdp_pincode', pin); } catch (e) {}
        } catch (e) {
          show('Could not check this pincode right now. Please try again.', false);
        } finally {
          btn.disabled = false; btn.textContent = 'Check';
        }
      };
      btn.addEventListener('click', check);
      input.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); check(); } });
      input.addEventListener('input', () => { input.value = input.value.replace(/\D/g, '').slice(0, 6); });
    }
  }
  customElements.define('kh-pdp', KhPdp);
}

  } catch(e) { console.error(e); }
})();
})();
